module.exports = __webpack_public_path__ + "static/BentonSansExtraComp-Bold-92df866e02dc22e46387f48a7629235a.woff";